import React from 'react'
import { makeStyles } from '@mui/styles'
import IconArrowRight from '@assets/images/icons/arr_right.svg'
import theme from '@/theme'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'

const Info = (props) => {
  const classes = useStyles()
  const { onClick, customClass, text, shouldRender, children } = props

  if (!shouldRender) return children ?? null

  return (
    <div className={classes.confirmEmailWrapper} onClick={onClick}>
      <span className={clsx(classes.confirmEmail, customClass.confirmEmail)} >
        {text}
      </span>
      <SVGIcon svg={IconArrowRight} fill={theme.red} width='14px' height='14px' />
    </div>
  )
}
Info.propTypes = {
  onClick: PropTypes.func.isRequired,
  customClass: PropTypes.object,
  text: PropTypes.string.isRequired,
  shouldRender: PropTypes.bool.isRequired,
}

Info.defaultProps = {
  customClass: {},
  text: '',
  shouldRender: false,
}

const useStyles = makeStyles((theme) => ({
  confirmEmail: {
    fontSize: theme.fontSizes.default,
    color: theme.red,
    maxWidth: 330,
    lineHeight: 'normal',
    overflow: 'hidden',
  },
  confirmEmailWrapper: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '5px',
  },
  [theme.devices.mobile]: {
    confirmEmail: {
      fontSize: theme.fontSizes.smaller,
      fontWeight: theme.fontWeights.regular,
    },
  },
}))

export default Info
